export const apiRoutes = {
  getAdvertiserInsertionOrders: () => `/user-profile/advertiser-insertion-orders`,
  postAdvertiserInsertionOrder: () => `/user-profile/advertiser-insertion-orders`,
  putAdvertiserInsertionOrder: (advertiserInsertionOrderId: string) =>
    `/user-profile/advertiser-insertion-orders/${advertiserInsertionOrderId}`,
};
